<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.auth_config">
    <div *ngIf="!isOtpVerified && businessId && businessId.length > 5" class="center" style="max-width: 400px;">
        <app-otp-container (onVerified)="onVerifiedOtp($event)" [isShowRequestOtp]="true" [businessId]="businessId"
            [otpType]="16" [interactionType]="interactionType" [isOtpVerified]="isOtpVerified"
            [requestOtpLabel]="localService.languageContent.common.request_otp" />
    </div>
    <div *ngIf="isOtpVerified" class="banner center" style="max-width: 500px;">
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button class="button_icon button_icon_color icon_adjust" (click)="onLoad()"
                    style="top: 0px !important;">refresh</button>
            </div>
        </div>
        <div *ngIf="authConfigUi">
            <div *ngIf="authConfigType == AuthConfigType.BunnyStorage && authConfigUi.bunnyStorage">
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <label>{{localService.languageContent.auth_config.bunny_storage}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.auth_config.base_host_name"
                                [IsMandatory]="true" />
                        </div>
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                [(ngModel)]="authConfigUi.bunnyStorage.BaseHostName"
                                title="{{localService.languageContent.auth_config.base_host_name}}"
                                placeholder="{{localService.languageContent.auth_config.base_host_name}}" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.auth_config.region" />
                        </div>
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                [(ngModel)]="authConfigUi.bunnyStorage.Region"
                                title="{{localService.languageContent.auth_config.region}}"
                                placeholder="{{localService.languageContent.auth_config.region}}" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.auth_config.storage_zone_name"
                                [IsMandatory]="true" />
                        </div>
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                [(ngModel)]="authConfigUi.bunnyStorage.StorageZoneName"
                                title="{{localService.languageContent.auth_config.storage_zone_name}}"
                                placeholder="{{localService.languageContent.auth_config.storage_zone_name}}" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.auth_config.access_key"
                                [IsMandatory]="true" />
                        </div>
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                [(ngModel)]="authConfigUi.bunnyStorage.AccessKey"
                                title="{{localService.languageContent.auth_config.access_key}}"
                                placeholder="{{localService.languageContent.auth_config.access_key}}" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <app-label [Text]="localService.languageContent.auth_config.view_base_domain"
                                [IsMandatory]="true" />
                        </div>
                        <div>
                            <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                [(ngModel)]="authConfigUi.bunnyStorage.ViewBaseDomain"
                                title="{{localService.languageContent.auth_config.view_base_domain}}"
                                placeholder="{{localService.languageContent.auth_config.view_base_domain}}" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="authConfigUi.key">
                <div class="col-12">
                    <label style="font-weight: normal;margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="authConfigUi.isActive" />
                        <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-7">
                    <div *ngIf="authConfigType == AuthConfigType.BunnyStorage && authConfigUi.key">
                        <button type="button" class="btn btn-primary" (click)="onAction(2)">
                            {{localService.languageContent.auth_config.sample_upload}}
                        </button>
                        <button *ngIf="authConfigUi.viewUrl && authConfigUi.viewUrl.length > 0"
                            class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;float: right;"
                            (click)="onAction(3)">image</button>
                        <button *ngIf="authConfigUi.viewUrl && authConfigUi.viewUrl.length > 0"
                            class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;float: right;"
                            (click)="localService.copyContent(authConfigUi.viewUrl)">
                            content_copy
                        </button>
                        <div style="display: none;">
                            <app-file-upload *ngIf="isOpenSampleFileUpload" (onFileUploaded)="onLoad()"
                                [forId]="sampleParentId" [forId2]="businessId" [fileUploadFor]="FileUploadFor.Gallery"
                                [type]="GalleryType.ReceiptFileSample" [isAutoOpen]="true"></app-file-upload>
                        </div>
                    </div>
                </div>
                <div class="col-5" style="text-align: right;">
                    <button type="button" class="btn btn-primary" (click)="onAction(1)">{{!authConfigUi.key ?
                        localService.languageContent.common.create :
                        localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
</div>